import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 } from 'uuid';
import NotificationItem from './NotificationItem';
const fedConnector = window.getFederationConnector();

export default class NotificationPanel extends Component {
    constructor(props) {
        super(props);
        this.state = { items: [] };

        this.close = this.close.bind(this);
    }

    close(event) {
        const list = this.state.items;
        const index = _.findIndex(list, item => {
            return event.id === item.id;
        });
        let nextState = { ...this.state, items: [...list.slice(0, index), ...list.slice(index + 1)] };
        this.setState(nextState);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.events !== this.props.events) {
            /**
             * on single mode, we propagate notification's data to be managed
             * by the host instead of presenting it here.
             */
            if (window.singlemode) {
                fedConnector.sendMessage('notification', this.props.events);
                return;
            }
            let nextState = { ...this.state };
            this.props.events.forEach(function (event) {
                switch (event.action || 'add') {
                    case 'add':
                        nextState = this.addNotification(nextState, event);
                        break;
                    case 'remove':
                        nextState = this.removeNotification(nextState, event);
                        break;
                    case 'initialize':
                        nextState = this.initialize(nextState);
                        break;
                }
            }, this);
            this.setState(nextState);
        }
    }

    getStyle({ style }) {
        const _style = (style && style.toLowerCase()) || 'error';
        switch (_style) {
            case 'error':
                return 'notification-item-error';
            case 'success':
                return 'notification-item-success';
            case 'info':
                return 'notification-item-info';
            default:
                return style;
        }
    }

    addNotification(state, event) {
        const list = state.items;
        const newItem = { ...this.props.defaultEvent, id: v4(), ...event, style: this.getStyle(event) };
        const pos = _.findIndex(list, item => {
            return this.areSame(item, newItem);
        });
        if (pos !== -1) {
            const copy = { ...list[pos], repeat: list[pos].repeat + 1 };
            return { ...state, items: [copy, ...list.slice(0, pos), ...list.slice(pos + 1)] };
        } else {
            return { ...state, items: [...list, newItem] };
        }
    }

    removeNotification(state, event) {
        const list = this.state.items;
        const pos = _.findIndex(list, item => {
            return this.areSame(item, event);
        });
        if (pos !== -1) {
            return { ...state, items: [...list.slice(0, pos), ...list.slice(pos + 1)] };
        }
        return this.state;
    }

    initialize(state) {
        return { ...state, items: [] };
    }

    areSame(left, right) {
        return (
            left.id !== right.id &&
            left.type === right.type &&
            left.text === right.text &&
            typeof left.time === 'undefined' &&
            typeof right.time === 'undefined'
        );
    }

    render() {
        return (
            <div className="notifications" data-debug-id="Notifications_Area">
                {this.state.items.slice(0, this.props.itemNumber).map(item => (
                    <NotificationItem event={item} key={item.id} closeDelegate={this.close} />
                ))}
            </div>
        );
    }
}

NotificationPanel.defaultProps = {
    items: [],
    defaultEvent: { type: 'info', text: 'info', repeat: 0 },
    itemNumber: 6,
};

NotificationPanel.propTypes = {
    events: PropTypes.array,
    defaultEvent: PropTypes.object,
    itemNumber: PropTypes.number,
};
